export default {
  "InfoIconUpdate.Text": "更新",
}
